<template>
  <li class="card">
    <button @click="$emit('settingsDropdown')" class="settings-dropdown">
      <i class="fal fa-pencil-alt" />
    </button>
    <div @click="$emit('selectClass')" >
      <div class="card-head">
        <div class="card-head-container">
          <span class="card-head-draft">
            <i class="fa-solid fa-period fa-xl mr-2" />
            <span class="card-head_text">Active - {{ card.code }}</span>
          </span>
        </div>
        <h3 class="card-head_title" v-line-clamp="2">
          {{ card.name }}
        </h3>
      </div>
      <div class="card-content cursor-pointer" v-bind:style="classImageURL(classImage)">
      <span class="card-content-icon">
        <i class="fa-solid fa-circle-arrow-right fa-xl" />
      </span>
      </div>
    </div>
  </li>
</template>

<script>

import Vue from 'vue'
import lineClamp from 'vue-line-clamp'
import imageProxy from '@/libs/image-proxy'

Vue.use(lineClamp, {
  textOverflow: 'ellipsis'
})

export default {

  props: {
    card: {
      type: Object,
      required: true
    },
    classImage: {
      type: String,
      required: false
    }
  },
  methods: {
    classImageURL: function (imageURL) {
      const style = {}
      if (imageURL) {
        const proxiedImageURL = imageProxy.proxy(imageURL, { width: 300, height: 300 })
        style.backgroundImage = `url('${proxiedImageURL}')`
        return style
      } else {
        style.backgroundImage = 'linear-gradient(#3b82f6, #06b6d4)'
        return style
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.settings-dropdown {
  position: absolute;
  right: 3%;
  top: 4%;
  z-index: 1;
  border-radius: 50%;
  width: 1.75rem;
  height: 1.75rem;
  background: white;
  border: none;
  cursor: pointer;
  &:hover {
    background: #F0F0F0;
  }
}
.card {
  width: 18rem;
  cursor: pointer;
  border-radius: 15px;
  &-head {
    padding: 1rem;
    background: white;
    border-radius: 15px;
    height: 6.5rem;
    &-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;

    }
    &-draft {
      display: flex;
      flex-direction: row;
      color: #9CA3AF;
    }
    &_text {
      font-size: 0.75rem;
      line-height: 1rem;
    }
    &_title {
      padding-top: 0.75rem;
      font-weight: 700;
    }
  }
  &-content {
    display: flex;
    height: 9rem;
    align-items: flex-end;
    justify-content: flex-end;
    border-bottom-left-radius: 15px !important;
    border-bottom-right-radius: 15px !important;
    background-position: center;
    &-icon {
      border-radius: 50%;
      background-color: white;
    }
  }
}
</style>
